import { createContext } from 'react';
const myContext = createContext([] as any); //创建了自己的ContContext 
export default myContext